import React, { useEffect } from "react";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import api from "store/api/api";

const Generatepdf = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const pdfParams = {
    pdf_type: "logs",
    type: searchParams.get("type"),
    id: searchParams.get("id"),
    token: searchParams.get("token"),
  };

  async function checkInspectionAvailable() {
    if (pdfParams?.type === "") {
      toast.error(
        "Please provide the type of the Deficiency, Project or inspetion"
      );
      return;
    }

    if (pdfParams?.id == "") {
      toast.error("Please Provide the id");
      return;
    }

    if (pdfParams?.token == "") {
      toast.error("Please Provide the Token");
    }

      // const response = await api.logsExist({});

     const url = `https://api.cciportal.com/deficiencylog/checkLogsExist`

     try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${pdfParams?.token}`, // Ensure token is valid
          "apiKey": "G6EAQa1Pim694FUY&SZ8C5nbQuKD3", // Custom API key
        },
        body: JSON.stringify({
          id: pdfParams?.id,
          type: pdfParams?.type,
        }),
      });
  
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response:", errorData);
        throw new Error(`Request failed with status ${response.status}`);
      }
  
      // Parse and log the successful response
      const data = await response.json();
      
      if(data?.status == 1){
        downloadPDF();
      }
      else if(data?.status  == 0){
         toast.error(response?.message || "Error In download pdf");
      }

      return;
    } catch (error) {
      console.error("Fetch error:", error.message);
      return null;
    }
  }

  // Function to call PDF generation API
  async function downloadPDF() {
    try {
      const url = `https://api.cciportal.com/generate-pdf?id=${pdfParams?.id}&type=${pdfParams?.type}&token=${pdfParams?.token}`;

      // Fetch the PDF from the API
      const response = await fetch(url);

      if (response.status == 0) {
        toast.error(response?.message || "Error in downloading pdf");
        return;
      }

      if (response.ok) {
        // Convert the response to a Blob (binary large object)
        const blob = await response.blob();
        const link = document.createElement("a");

        // Create a temporary link to download the file
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = `${pdfParams?.id}_deficiency-log.pdf`; // You can set the filename dynamically here
        document.body.appendChild(link);
        link.click();

        // Clean up the URL object after download
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } else {
        // Handle the error if the response is not ok
        console.error("Failed to download PDF:", response.statusText);
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  }

  // Trigger PDF generation on first render

  useEffect(() => {
    checkInspectionAvailable();
  }, []);
};

export default Generatepdf;
